import { Helmet, HelmetProvider } from "react-helmet-async";
import '../css/style.css';
import '../css/responsive.css';

import logo from '../img/trasc_logo.png';
import QuoteModal from "./QuoteModal";
import { useEffect, useState } from "react";


 
function Header() {

   const [isModalOpen, setIsModalOpen] = useState(false);

   const [menuOpen, setMenuOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

 
useEffect(() => {
  const timer = setTimeout(() => {
    if (
      window.$ &&
      typeof window.$.fn.stellarNav === "function" &&
      document.querySelector(".stellarnav")
    ) {
      window.$(".stellarnav").stellarNav({
        theme: "light",
        breakpoint: 768,
        position: "right",
        phoneBtn: false,
        locationBtn: false,
        sticky: false,
      });
    } else {
      console.warn("StellarNav not initialized – jQuery or target missing");
    }
  }, 100); // Delay ensures DOM and scripts are loaded

  return () => clearTimeout(timer);
}, []);


  return (
    <>
      <HelmetProvider>
        <Helmet>
          {/* Basic Page Needs */}
          <meta charSet="utf-8" />
          <title>Tracs</title>
          <meta name="description" content="" />
          <meta name="author" content="" />
          <meta name="keywords" content="" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

          {/* Mobile Specific Meta */}
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
          <link rel="apple-touch-icon" href="apple-touch-icon.png" />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"></link>
        </Helmet>

        {/* All your header HTML below */}
        {/* <div id="loader-wrapper">
          <div id="loader"></div>
        </div> */}

        <header className="h1-header-top-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="h1-single-top-block text-center">
                  <i className="fa fa-phone" aria-hidden="true"></i>
                  <strong>Call:</strong>
                  <span> +61 08 9353 4544</span>
                </div>
                <div className="h1-single-top-block text-center">
                  <i className="fa fa-clock-o" aria-hidden="true"></i>
                  <strong>Mon - Fri:</strong>
                  <span> 8:00 - 17:00 / Closed on Weekends</span>
                </div>
                <div className="h1-single-top-block text-center">
                  <i className="fa fa-envelope-o" aria-hidden="true"></i>
                  <strong>Email:</strong>
                  <a href="mailto:tracs@tracs.com.au" target="_top" style={{color:'#fff'}}> tracs@tracs.com.au</a>
                </div>
              </div>
              {/* <div className="col-lg-3 col-md-3 col-sm-12 col-12">
                <div className="h1-social-media">
                  <ul>
                    <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                    <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                    <li><a href="#"><i className="fab fa-skype"></i></a></li>
                    <li><a href="#"><i className="fab fa-linkedin-in"></i></a></li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </header>
      </HelmetProvider>

<div id="main-nav" className="h1-navigation-area">
      <nav className="container">
        <div className="row">
          <div className="col-lg-12 d-flex justify-content-between align-items-center">
            <div className="logo">
              <a className="navbar-brand" href="/">
                <img src={logo} alt="Logo" className="logo-img" />
              </a>
            </div>
            <div className="main-nav-area">
              <div className="stellarnav">
                <ul >
                  <li><a href="/">Home</a></li>
                  <li><a href="/about">About Us</a></li>
                  <li><a href="/services">Services</a></li>
                  <li><a href="/projects">Projects</a></li>
                  <li><a href="/contact">Contact</a></li>
                </ul>
              </div>
              <div className="nav-serch-area">
                <div className="form-inline my-2 my-lg-0">
                  <a
                    href="/contact"
                    className="get_quote btn text-light my-2 my-sm-0"
                    onClick={handleOpenModal}
                  >
                    Get A Quote
                  </a>
                  <QuoteModal isOpen={isModalOpen} onClose={handleCloseModal} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>

      {/* <div id="main-nav" className="h1-navigation-area">
  <nav className="container">
    <div className="row">
      <div className="col-lg-12 d-flex justify-content-between align-items-center">
        <div className="logo">
          <a className="navbar-brand" href="/">
            <img src={logo} alt="Logo" className="logo-img" />
          </a>
        </div>
        <div className="main-nav-area">
          <div className="stellarnav">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/projects">Projects</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
          <div className="nav-serch-area">
            <div id="inline-popups" className="form-inline my-2 my-lg-0">
            
             <a href="/contact" className="get_quote btn text-light my-2 my-sm-0" onClick={handleOpenModal}>
        Get A Quote
      </a>




      <QuoteModal isOpen={isModalOpen} onClose={handleCloseModal} />
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div> */}


    </>
  );
}

export default Header;
